// extracted by mini-css-extract-plugin
module.exports = {"previewOverlay":"PreviewOverlay_previewOverlay__1qlGd","previewImg":"PreviewOverlay_previewImg__18bVS"};